import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks/index';

type Params = {
  kolSearchId: number;
};

export const useDownloadKolSearch = (params: Params) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `brand-insights:kol-search:download`,
      params.kolSearchId,
    ],
    queryFn: ({ queryKey: [, kolSearchId] }) => {
      return apiClient.kolSearch.downloadKolSearch({ kolSearchId });
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: res.filename,
        type: 'blob',
        value: res.blob,
      }),
    },
  });

};